import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts a number to its ordinal string representation.
 * Examples: 1 → '1st', 2 → '2nd', 3 → '3rd', 4 → '4th'
 *
 * Usage in template:
 *   {{ item.monthly_sequence | ordinal }}  →  "3rd"
 *   {{ item.monthly_sequence | ordinal:true }}  →  "3rd Request"
 */
@Pipe({
  name: 'ordinal',
  standalone: true,
  pure: true,
})
export class OrdinalPipe implements PipeTransform {
  transform(n: number | null | undefined, appendRequest = false): string {
    if (n === null || n === undefined) {
      return '';
    }

    const suffix = this.getSuffix(n);
    const ordinal = `${n}${suffix}`;
    return appendRequest ? `${ordinal} Request` : ordinal;
  }

  private getSuffix(n: number): string {
    const abs = Math.abs(n);
    const mod100 = abs % 100;

    // 11th, 12th, 13th are special cases
    if (mod100 >= 11 && mod100 <= 13) {
      return 'th';
    }

    switch (abs % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  }
}
